// / — главная: приветствие и пустое состояние до документов. 030 (T019, T020; FR-031, FR-034;
// ASG-DESK-07): у сеанса по ссылке и у связанного с человеком сотрудника без ролей «Главная» — это
// «Мои задачи»: адрес «/» ведёт в «/my» с заменой записи истории.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { HomePage } from '../../features/home/HomePage.tsx';
import { MY_ITEMS_PATH, homeIsMyItems } from '../../shell/permissions.ts';
import { meQuery } from '../../shell/session.ts';

export const Route = createFileRoute('/_app/')({
  staticData: { crumb: 'Главная' },
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery());
    if (homeIsMyItems(me)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- так TanStack Router перенаправляет
      throw redirect({ to: MY_ITEMS_PATH, replace: true });
    }
  },
  component: HomePage,
});
